import { render, staticRenderFns } from "./SponsorsEditor.vue?vue&type=template&id=1ca4c3b7&scoped=true&"
import script from "./SponsorsEditor.vue?vue&type=script&lang=js&"
export * from "./SponsorsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsEditor.vue?vue&type=style&index=0&id=1ca4c3b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4c3b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VRow,VTextField,VTextarea})
